import CSelect from "components/CSelect";
import useAjax from "helpers/ajax";
import { useAuth } from "helpers/auth";
import { showError, showMessage } from "helpers/utility";
import { useEffect, useState } from "react";

const { Drawer, Form, Select, Space, Button } = require("antd");

const CouponTransfer = ({ title, visible, onClose, keys }) => {
  const {
    user: { companyID },
  } = useAuth();
  const { get, post } = useAjax();
  const [distributors, setDistributors] = useState([]);

  const onFinish = ({ companyID }) => {
    post("api/v1/coupons/transfer", { companyID, licenseIDs: keys })
      .then((resp) => {
        showMessage(resp.success, resp.message).then(() => {
          if (resp.success) {
            onClose(true);
          }
        });
      })
      .catch((err) => {
        showError(err);
      });
  };

  useEffect(() => {
    get("api/v1/lookups/distributors")
      .then((resp) => {
        // exclude itself from the list
        const items = resp.filter((x) => x.value !== companyID);
        setDistributors(items);
      })
      .catch((err) => {
        showError(err);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Drawer title={title} visible={visible} onClose={onClose}>
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Distributor name"
          name="companyID"
          rules={[{ required: true }]}
        >
          <CSelect allowClear={true}>
            {distributors.map((r) => (
              <Select.Option key={r.value} value={r.value}>
                {r.text}
              </Select.Option>
            ))}
          </CSelect>
        </Form.Item>
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
            <Button
              htmlType="button"
              onClick={() => {
                onClose(false);
              }}
            >
              Cancel
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Drawer>
  );
};
export default CouponTransfer;
